import {useFormik} from 'formik';
import {useSchemes} from '../../../shared';
import {useState} from 'react';
import {useBenefactorById, BenefactorModel} from '../../../entities';
import * as Yup from 'yup';
import {AxiosError} from 'axios';

type UseEditBenefactorEmailFormProps = {
  setOpen: (open: boolean) => void;
  benefactorId: string;
  benefactor?: BenefactorModel;
};

export const useEditBenefactorEmailForm = ({setOpen, benefactorId, benefactor}: UseEditBenefactorEmailFormProps) => {
  const {emailSchema} = useSchemes();
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const {updateBenefactorEmailMutation} = useBenefactorById(benefactorId);

  const onSubmit = async (values: {email: string}) => {
    setErrorMessage(null);
    try {
      await updateBenefactorEmailMutation.mutateAsync({benefactorId, email: values.email});
      setOpen(false);
    } catch (error: any) {
      setErrorMessage(error?.response?.data?.detail || 'Произошла ошибка при обновлении email');
    }
  };

  const formik = useFormik({
    initialValues: {
      email: benefactor?.email || '',
    },
    validationSchema: Yup.object({
      email: emailSchema,
    }),
    onSubmit,
    enableReinitialize: true,
  });

  return {
    ...formik,
    isLoading: updateBenefactorEmailMutation.isPending,
    errorMessage,
    submitError: updateBenefactorEmailMutation.error ? (updateBenefactorEmailMutation.error as AxiosError<ApiError>)?.response?.data : null,
    submitForm: () => formik.handleSubmit(),
  };
};
